import React from 'react';
import { Col, Row } from 'reactstrap';
import { version } from '../../config';

const Footer = (Props) => (
  <footer>
    <Row noGutters className="justify-content-between text-center fs--1 mt-4 mb-3 df fd-c" style={{display:Props.forgott_style}} >
      <Col sm="auto">
        <p className="mb-0 text-600">
          Gizmott <span className="d-none d-sm-inline-block">| </span>
          <br className="d-sm-none" /> {new Date().getFullYear()} &copy; <a href="https://gizmott.com">US</a>
        </p>
      </Col>
      {/* <Col sm="auto">
        <p className="mb-0 text-600">v{version}</p>
      </Col> */}
    </Row>
  </footer>
);

export default Footer;
